import { queryStringToObject } from '@buzzfeed/bf-utils/lib/query-string';
import { isOrHasQuiz } from '../../utils/isOrHasQuiz';
import { isGamesPost } from '../../utils/games';
import { getUserGeo } from '../../utils/localization';
import { getBuzzTags } from '../../utils/ads/context';
import { isAdLite } from '@buzzfeed/bf-utils/lib/ad-lite';

export function cleanLink(str) {
  return str
    .replace('http://', '')
    .replace('https://', '')
    .replace('www.', '');
}

export function isPermutiveDisabled(buzz) {
  if (typeof window === 'undefined') {
    return false;
  }
  const queryParams = queryStringToObject(window?.location?.search);
  const userGeo = getUserGeo()?.toLowerCase();

  return queryParams['origin']?.includes('sdxa') ||
    queryParams['origin'] === 'fsbfdc' ||
    queryParams['utm_medium'] === 'h5d' ||
    (isOrHasQuiz(buzz) && userGeo === 'us') ||
    (isGamesPost(buzz) && userGeo === 'us') ||
    isAdLite(getBuzzTags(buzz));
}
